<template>
  <ValidationObserver ref="cocForm">
    <div class="card card-custom">
      <div class="card-body container">

        <div class="card-body p-0">
          <!--begin: Wizard-->
          <div id="cocFormWizard" class="wizard wizard-3" data-wizard-state="step-first">
            <!--begin: Wizard Body-->
            <div class="card card-custom card-shadowless rounded-top-0">
              <div class="card-body p-0">
                <div class="row justify-content-center py-8 px-8 py-lg-10 px-lg-10">
                  <div class="col-xl-12 col-xxl-12">
                    <!--begin: Wizard Form-->
                    <div class="form mt-0" id="kt_form">

                      <!--begin: ERROR ALERT-->
                      <b-alert v-if="errorAlert" variant="warning" show>
                        <div class="text-dark" v-html="errorAlert"></div>
                      </b-alert>
                      <!--end: ERROR ALERT-->

                      <div v-if="refData">
                        <div class="form-group row mb-2">
                          <div class="col-12">
                            <label class="col-form-label text-left font-size-h4"><strong>Select a Policy</strong></label>
                            <v-autocomplete
                                class="mt-0 pt-0 mb-0" color="white" size="md" :item-text="getPolicyDisplayName" label="Search by client name or policy number (minimum 3 characters)"
                                :items="refData.policies" v-model="selectedPolicyId" item-value="id" @change="policySelected"
                            ></v-autocomplete>
                          </div>
                        </div>

                        <div v-if="selectedPolicyId">
                          <label class="col-form-label text-left font-weight-bold font-size-h4"><strong>Select Options</strong></label>
                          <div v-if="loadingOptions">
                            <b-spinner size="lg"></b-spinner>
                          </div>

                          <div v-if="!loadingOptions">
                            <b-card body-class="p-2" border-variant="primary">
                              <div class="row col-12">
                                <span class="switch switch-sm switch-outline switch-icon switch-primary">
                                  <label>
                                    <input type="checkbox" v-model="cocOptions.includeInterestedParties"/>
                                    <span></span>
                                  </label>
                                </span>
                                <label class="col-form-label ml-2 font-weight-bold">Include Interested Parties</label>
                              </div>

                              <div v-if="cocOptions.includeInterestedParties" class="mb-5">
                                <div class="form-group col-12 mt-5">
                                  <label class="col-form-label"><strong>Policy Interested Parties: </strong>
                                  <span v-if="!Array.isArray(cocOptions.interestedParties) || cocOptions.interestedParties.length === 0">
                                    None
                                  </span>
                                  </label>
                                </div>
                                <div style="max-height: 500px; overflow-y: scroll;" class="col-6">
                                  <table class="table table-bordered table-sm"
                                         v-if="Array.isArray(cocOptions.interestedParties) && cocOptions.interestedParties.length > 0">
                                    <th class="text-center" width="10%">Selected for CoC</th>
                                    <th class="text-center" width="80%">Name</th>
                                    <th class="text-center" width="10%"></th>

                                    <tr v-for="(ip, index) in cocOptions.interestedParties" :key="index">
                                      <td class="text-center">
                                        <input type="checkbox" v-model="ip.selectedForCoc"/>
                                      </td>
                                      <td class="text-center">
                                        <input type="text" v-model="ip.name" disabled>
                                      </td>
                                      <td class="text-center">
                                        <button class="btn btn-sm btn-outline-danger p-1" @click.prevent="deleteInterestedParty(index)"
                                                title="Delete Interested Party" :disabled="deletingInterestedParty">
                                          <i class="fa fa-trash-alt"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                                <ValidationProvider :rules="{'required': { allowFalse: false }}" name="interestedPartiesSelected" v-slot="{ errors }">
                                  <input v-model="interestedPartiesSelected" hidden/>
                                  <span class="text-danger">{{ errors[0] ? 'Select at least 1 interested party' : null }}</span>
                                </ValidationProvider>
                                <div class="form-group col-12">
                                  <button class="btn btn-outline-primary" @click.prevent="showInterestedPartyModal"
                                          :disabled="addingInterestedParty || deletingInterestedParty">
                                    Add New Interested Party
                                  </button>
                                  <b-spinner v-if="addingInterestedParty" variant="primary" class="ml-3 align-middle"></b-spinner>
                                </div>
                                <b-modal ref="addInterestedPartyModal" title="Add New Interested Party" size="md" no-close-on-backdrop hide-header-close
                                         @ok="addInterestedParty">
                                    <div class="form-group col-12">
                                      Add Interested Party to Policy
                                      <ValidationProvider rules="required|max:255" name="ipToBeAdded" v-slot="{ errors }">
                                        <v-combobox
                                            v-model="ipToBeAdded" :items="refData.interestedParties"
                                            label="Select an existing party or type a new one"
                                            chips deletable-chips clearable
                                        ></v-combobox>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                      </ValidationProvider>
                                    </div>
                                </b-modal>
                              </div>
                            </b-card>

                            <b-card class="mt-5" body-class="p-2" border-variant="primary">
                              <div class="row col-12">
                                <span class="switch switch-sm switch-outline switch-icon switch-primary">
                                  <label>
                                    <input type="checkbox" v-model="cocOptions.includeVehicles"/>
                                    <span></span>
                                  </label>
                                </span>
                                <label class="col-form-label ml-2 font-weight-bold">Include Vehicles / Nominated Drivers</label>
                              </div>
                              <div v-if="cocOptions.includeVehicles" class="mb-5">
<!--                                <div class="form-group ml-5">-->
<!--                                  <ValidationProvider rules="required" name="vehicleInclusionTypeOption" v-slot="{ errors }">-->
<!--                                    <b-form-radio size="lg" v-model="cocOptions.vehicleInclusionType" name="vehicleInclusionType" value="allVehicles">-->
<!--                                      <div class="font-weight-bold pt-1">All Vehicles</div>-->
<!--                                    </b-form-radio>-->
<!--                                    <b-form-radio size="lg" v-model="cocOptions.vehicleInclusionType" name="vehicleInclusionType" value="selectedVehicles">-->
<!--                                      <div class="font-weight-bold pt-1">Selected Vehicles</div>-->
<!--                                    </b-form-radio>-->
<!--                                    <span class="text-danger">{{ errors[0] ? 'Select an option' : null }}</span>-->
<!--                                  </ValidationProvider>-->
<!--                                </div>-->

                                <div v-if="cocOptions.vehicleInclusionType === 'selectedVehicles'" class="form-group col-12 mt-5">
                                  <label class="col-form-label mb-0 font-weight-bold">Search Vehicle</label>

                                  <div class="form-group row mb-5">
                                    <div class="col-1">
                                      <label class="col-form-label text-right">Rego</label>
                                    </div>
                                    <div class="col-2">
                                      <input type="text" class="form-control text-uppercase" v-model="vehicleRego"/>
                                    </div>
                                    <div class="col-1">
                                      <label class="col-form-label text-right">State</label>
                                    </div>
                                    <div class="col-2">
                                      <b-form-select class="form-control" v-model="vehicleState">
                                        <option value="NSW">NSW</option>
                                        <option value="VIC">VIC</option>
                                        <option value="ACT">ACT</option>
                                        <option value="QLD">QLD</option>
                                        <option value="WA">WA</option>
                                        <option value="SA">SA</option>
                                        <option value="NT">NT</option>
                                        <option value="TAS">TAS</option>
                                        <option value="NZ">NZ</option>
                                      </b-form-select>
                                    </div>
                                    <div>
                                    <button class="btn btn-outline-primary" :disabled="searchingVehicle || !vehicleRego || !vehicleState"
                                            @click.prevent="addVehicle">
                                      Search
                                    </button>
                                    <b-spinner v-if="searchingVehicle" variant="primary" class="ml-3 align-middle"></b-spinner>
                                    </div>
                                  </div>
                                  <div style="max-height: 500px; overflow-y: scroll;">
                                    <table class="table table-bordered table-sm" v-if="Array.isArray(cocOptions.selectedVehicles)">
                                      <th class="text-center" width="10%">Rego<span class="text-danger">*</span></th>
                                      <th class="text-center" width="8%">State<span class="text-danger">*</span></th>
                                      <th class="text-center" width="20%">Make<span class="text-danger">*</span></th>
                                      <th class="text-center" width="20%">Model<span class="text-danger">*</span></th>
                                      <th class="text-center" width="9%">Year<span class="text-danger">*</span></th>
                                      <th class="text-center" width="30%">Nominated Drivers (Optional)</th>
                                      <th class="text-center" width="3%"></th>

                                      <tr v-for="(vehicle, index) in cocOptions.selectedVehicles" :key="index">
                                        <td>
                                          <ValidationProvider rules="required|max:10" :name="`vehicle${index}.rego`" v-slot="{ errors }">
                                            <b-form-input size="sm" type="text" maxlength="10" class="form-control" v-model.trim="vehicle.K_RegoNo" disabled/>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td>
                                          <ValidationProvider rules="required" :name="`vehicle${index}.state`" v-slot="{ errors }">
                                            <b-form-select size="sm" class="form-control" v-model="vehicle.K_State" disabled>
                                              <option value="NSW">NSW</option>
                                              <option value="VIC">VIC</option>
                                              <option value="ACT">ACT</option>
                                              <option value="QLD">QLD</option>
                                              <option value="WA">WA</option>
                                              <option value="SA">SA</option>
                                              <option value="NT">NT</option>
                                              <option value="TAS">TAS</option>
                                              <option value="NZ">NZ</option>
                                            </b-form-select>
                                            <span class="text-danger"><br>{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td>
                                          <ValidationProvider rules="required|max:255" :name="`vehicle${index}.K_Make`" v-slot="{ errors }">
                                            <b-form-input size="sm" type="text" maxlength="255" class="form-control" v-model.trim="vehicle.K_Make" disabled/>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td>
                                          <ValidationProvider rules="required|max:255" :name="`vehicle${index}.K_Model`" v-slot="{ errors }">
                                            <b-form-input size="sm" type="text" maxlength="255" class="form-control" v-model.trim="vehicle.K_Model" disabled/>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td>
                                          <ValidationProvider :rules="{required: true, 'max_value': currentYear}" :name="`vehicle${index}.K_Year`" v-slot="{ errors }">
                                            <b-form-input size="sm" type="number" :max="currentYear" class="form-control" v-model.trim="vehicle.K_Year" disabled/>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td>
                                          <ValidationProvider rules="max:2000" :name="`vehicle${index}.nominatedDrivers`" v-slot="{ errors }">
                                            <textarea class="form-control" rows="2" maxlength="2000" v-model="vehicle.nominatedDrivers"/>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                          </ValidationProvider>
                                        </td>
                                        <td class="text-center">
                                          <button class="btn btn-sm btn-outline-danger p-1" @click.prevent="deleteVehicle(index)" title="Delete">
                                            <i class="fa fa-trash-alt"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    </table>
                                    <ValidationProvider :rules="{'required': { allowFalse: false }}" name="vehiclesSelected" v-slot="{ errors }">
                                      <input v-model="vehiclesSelected" hidden/>
                                      <span class="text-danger">{{ errors[0] ? 'Enter at least 1 vehicle' : null }}</span>
                                    </ValidationProvider>
                                  </div>
                                </div>
                              </div>
                            </b-card>

                            <div class="d-flex justify-content-between border-top pt-8">
                              <div>
                                <button class="btn btn-success font-weight-bold"
                                        v-if="refData && selectedPolicyId" @click.prevent="submitForm"
                                >
                                  <i class="fa fa-file-invoice"></i>
                                  Generate CoC
                                </button>
                                <button class="btn btn-secondary font-weight-bold ml-5"
                                        @click.prevent="resetAll"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>

                            <div v-if="cocLinks" class="mt-10">
                              <label class="col-form-label">Certificate of Currency has been generated.</label>
                              <div class="form-group">
                                <a target="_blank" class="btn btn-primary font-weight-bold" :href="cocLinks.view_url">
                                  <i class="fa fa-external-link-alt"></i>
                                  View CoC
                                </a>
                                <a target="_blank" class="btn btn-primary font-weight-bold ml-5" :href="cocLinks.download_url">
                                  <i class="fa fa-file-download"></i>
                                  Download CoC
                                </a>
                              </div>
                              </div>
                          </div>
                        </div>
                      </div>

                      <!--begin: Wizard Actions -->
                      <!--end: Wizard Actions -->
                    </div>
                    <!--end: Wizard Form-->
                  </div>
                </div>
              </div>
            </div>
            <!--end: Wizard Body-->
          </div>
          <!--end: Wizard-->
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-3.scss";

.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-disabled {
  cursor: not-allowed !important;
}

body.swal2-shown > [aria-hidden="true"] {
  transition: 0.1s filter;
  filter: blur(10px);
}

</style>

<script>
import KTWizard from "@/assets/js/components/wizard";
import _ from "lodash";
import moment from "moment-timezone";
import KTUtil from "@/assets/js/components/util";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "CoCForm",

  data() {
    return {
      serverUrl: null,
      errorAlert: null,
      refData: null,
      wizardObj: null,
      selectedPolicyId: null,
      loadingOptions: false,
      cocLinks: null,

      vehicleRego: null,
      vehicleState: null,
      searchingVehicle: false,

      ipToBeAdded: null,
      addingInterestedParty: false,
      deletingInterestedParty: false,

      cocOptions: {
        includeInterestedParties: false,
        interestedParties: [],

        includeNominatedDrivers: false,
        nominatedDrivers: null,

        includeVehicles: false,
        vehicleInclusionType: 'selectedVehicles',
        selectedVehicles: []
      }
    };
  },

  mounted() {
    this.$store.commit("setWizardTitle", `Certificate of Currency`);
    this.initWizard();

    this.startPageLoading();

    // Extract information from URL params
    const queryParams = this.$route.query;

    // Get reference data
    ApiService.get(`/coc/ref-data`)
        .then(({ data }) => {
          this.refData = data.result;
          this.stopPageLoading();

          if(queryParams.policyId) {
            this.selectedPolicyId = queryParams.policyId;
            this.policySelected();
          }
        })
        .catch((error) => {
          this.handleError(error);
        });
  },

  computed: {
    interestedPartiesSelected: function () {
      if(Array.isArray(this.cocOptions.interestedParties)) {
        return _.some(this.cocOptions.interestedParties, ip => {
          return ip.selectedForCoc === true;
        });
      }
      return false;
    },

    vehiclesSelected: function () {
      return this.cocOptions.selectedVehicles.length > 0;
    },

    currentYear: function () {
      return new Date().getFullYear();
    }
  },

  methods: {
    policySelected: function () {
      if(!this.selectedPolicyId) {
        return;
      }
      this.clearError();
      this.resetOptions();

      this.loadingOptions = true;
      ApiService.get(`/coc/${this.selectedPolicyId}/interested-parties`)
          .then(({ data }) => {
            const interestedParties = [];
            if(Array.isArray(data.result)) {
              data.result.forEach(pip => {
                interestedParties.push({ name: pip, selectedForCoc: false});
              });
            }
            this.$set(this.cocOptions, 'interestedParties', interestedParties);

            this.loadingOptions = false;
          })
          .catch((error) => {
            this.handleError(error);
            this.loadingOptions = false;
          });
    },

    addVehicle: function () {
      this.clearError();
      this.vehicleRego = this.cleanRegoOrState(this.vehicleRego);
      this.vehicleState = this.cleanRegoOrState(this.vehicleState);

      this.searchingVehicle = true;
      ApiService.get(`/coc/${this.selectedPolicyId}/vehicle`,
          { params: { rego: this.vehicleRego, state: this.vehicleState }})
          .then(({ data }) => {
            const vehicle = data.result;
            if(vehicle) {
              this.cocOptions.selectedVehicles.push(vehicle);
              this.vehicleRego = null;
              this.vehicleState = null;
            }
            this.searchingVehicle = false;
          })
          .catch((error) => {
            this.handleError(error);
            this.searchingVehicle = false;
          });
    },

    deleteVehicle: function (index) {
      this.cocOptions.selectedVehicles.splice(index, 1);
    },

    cleanRegoOrState: function (value) {
      let newValue = null;
      if (value) {
        newValue = value.replace(/[^0-9a-z]/gi, "").toUpperCase();
        if (newValue === "NULL" || newValue === "UNDEFINED") {
          newValue = null;
        }
      }
      return newValue;
    },

    showInterestedPartyModal: function () {
      this.ipToBeAdded = null;
      this.$refs["addInterestedPartyModal"].show();
    },

    addInterestedParty: function (bvModalEvent) {
      const ip = this.ipToBeAdded ? this.ipToBeAdded.trim() : '';
      if (!ip || ip.length > 255) {
        bvModalEvent.preventDefault();
        return;
      }

      this.addingInterestedParty = true;
      ApiService.post(`/coc/${this.selectedPolicyId}/interested-party`,
          { interestedParty: ip})
          .then((/*{ data }*/) => {
            this.cocOptions.interestedParties.push({ name: ip, selectedForCoc: false });
            this.addingInterestedParty = false;
          })
          .catch((error) => {
            this.handleError(error);
            this.addingInterestedParty = false;
          });
    },

    deleteInterestedParty: function (index) {
      const ip = this.cocOptions.interestedParties[index].name;

      this.deletingInterestedParty = true;
      ApiService.post(`/coc/${this.selectedPolicyId}/interested-party/delete`,
          { interestedParty: ip})
          .then((/*{ data }*/) => {
            this.cocOptions.interestedParties.splice(index, 1);
            this.deletingInterestedParty = false;
          })
          .catch((error) => {
            this.handleError(error);
            this.deletingInterestedParty = false;
          });
    },

    submitForm: async function () {
      this.clearError();
      this.cocLinks = null;

      const isFormValid = await this.$refs.cocForm.validate();
      if(!isFormValid) {
        return;
      }

      // Clear unnecessary data
      if(!this.cocOptions.includeInterestedParties) {
        this.cocOptions.interestedParties = [];
      }
      if(!this.cocOptions.includeNominatedDrivers) {
        this.cocOptions.nominatedDrivers = null;
      }
      if(!this.cocOptions.includeVehicles) {
        this.cocOptions.vehicleInclusionType = 'selectedVehicles';
        this.cocOptions.selectedVehicles = [];
      }

      const reqBody = {
        cocOptions: this.cocOptions
      }
      this.startPageLoading();
      ApiService.post(`/coc/${this.selectedPolicyId}/generate`, reqBody)
          .then(({ data }) => {
            this.cocLinks = data.result;
            this.stopPageLoading();
          })
          .catch((error) => {
            this.handleError(error);
          });
    },

    resetOptions: function () {
      this.cocLinks = null;
      this.vehicleRego = null;
      this.vehicleState = null;

      this.cocOptions.includeInterestedParties = false;
      this.cocOptions.interestedParties = [];

      this.cocOptions.includeNominatedDrivers = false;
      this.cocOptions.nominatedDrivers = null;

      this.cocOptions.includeVehicles = false;
      this.cocOptions.vehicleInclusionType = 'selectedVehicles';
      this.cocOptions.selectedVehicles = [];
    },

    resetAll: function () {
      this.selectedPolicyId = null;
      this.resetOptions();
    },

    getPolicyDisplayName: function (policy) {
      const policyStartDate = moment.tz(policy.K_PolicyStartDate, 'YYYY-MM-DD', 'Australia/Sydney').format('DD/MM/YYYY');
      const policyEndDate = moment.tz(policy.K_PolicyEndDate, 'YYYY-MM-DD', 'Australia/Sydney').format('DD/MM/YYYY');
      return `${policy.K_Client.name} - ${policy.K_PolicyNumber} (${policyStartDate} to ${policyEndDate})`;
    },

    initWizard: function () {
      // Initialize form wizard
      const wizard = new KTWizard("cocFormWizard", {
        startStep: 1, // Initial active step number
        clickableSteps: false, // Do not allow step clicking
      });

      this.wizardObj = wizard;

      // Change event - Scroll to top of the page
      wizard.on("change", (/*wizardObj*/) => {
        setTimeout(function () {
          KTUtil.scrollTop();
        }, 500);
      });
    },

    setError: function (message) {
      KTUtil.scrollTop();
      this.errorAlert = message;
    },

    clearError: function () {
      this.errorAlert = null;
    },

    handleError: function(errorObj) {
      this.stopPageLoading();
      let errorMsg = null;

      if(errorObj) {
        let responseStatus = _.get(errorObj, "response.status");
        let errorMessage = errorObj.message || '';
        if (responseStatus === 401 || errorMessage.includes("status code 401") ||
            responseStatus === 403 || errorMessage.includes("status code 403")
        ) {
          errorMsg = "This session is invalid or expired. Please close this window.";
        }
        else {
          let responseResult = _.get(errorObj, "response.data.result");
          if (_.isString(responseResult)) {
            let applicationErrorPrefix = "UI_ERROR:";

            if (responseResult.startsWith(applicationErrorPrefix)) {
              errorMsg = responseResult.substring(applicationErrorPrefix.length, responseResult.length);
            }
          }
        }
      }
      if (!errorMsg) {
        console.log(errorObj);
        errorMsg = "An unexpected error has occurred.";
      }

      this.setError(errorMsg);
      KTUtil.scrollTop();
    },

    startPageLoading: function() {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    },

    stopPageLoading: function() {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }
  },
};
</script>
